module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_vm._v("用户列表")]), _vm._v(" "), _c('div', {
    staticClass: "search-wrapper"
  }, [_c('el-form', {
    attrs: {
      "label-width": "60px",
      "inline": true,
      "model": _vm.queryParam
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryParam.gender),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "gender", $$v)
      },
      expression: "queryParam.gender"
    }
  }, _vm._l((_vm.gender), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": index - 1
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角色"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryParam.roleId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "roleId", $$v)
      },
      expression: "queryParam.roleId"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": -1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "普通用户",
      "value": 0
    }
  }), _vm._v(" "), _vm._l((_vm.roles), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "校区"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryParam.unid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "unid", $$v)
      },
      expression: "queryParam.unid"
    }
  }, _vm._l((_vm.campuszones), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryParam.inviteStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "inviteStatus", $$v)
      },
      expression: "queryParam.inviteStatus"
    }
  }, _vm._l((_vm.inviteStatus), function(item, index) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": index - 1
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入昵称或姓名或手机搜索"
    },
    model: {
      value: (_vm.queryParam.searchKey),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "searchKey", $$v)
      },
      expression: "queryParam.searchKey"
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "margin-left-10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.queryList
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.clickReset
    }
  }, [_vm._v("重置")])], 1), _vm._v(" "), _c('div', {
    staticClass: "action-wrapper"
  }, [_c('el-button', {
    on: {
      "click": _vm.clickTemplateDownload
    }
  }, [_vm._v("模版下载")]), _vm._v(" "), _c('el-upload', {
    attrs: {
      "show-file-list": false,
      "with-credentials": true,
      "accept": ".xls,.xlsx",
      "action": _vm.actionUrl,
      "name": "uploadFile",
      "before-upload": _vm.beforeUpload,
      "on-success": _vm.onSuccess,
      "on-error": _vm.onError
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("导入赠送")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "uid",
      "label": "用户id",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户",
      "align": "center"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return [_vm._v(_vm._s(_vm.row.nickname) + "（" + _vm._s(_vm.row.name) + "）")]
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "性别",
      "align": "center"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return [_vm._v(_vm._s(_vm.gender[_vm.row.gender + 1]))]
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "手机",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rname",
      "label": "角色",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unname",
      "label": "校区",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最近登录时间",
      "align": "center",
      "width": "170px"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_vm._v(_vm._s(new Date(_vm.row.updatedAt).format("yyyy-MM-dd hh:mm:ss")))])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "邀请状态",
      "align": "center"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return [([0, 2].includes(_vm.row.inviteStatus)) ? _c('div', [_vm._v("可邀请")]) : _vm._e(), _vm._v(" "), ([1, 3].includes(_vm.row.inviteStatus)) ? _c('div', [_vm._v("\n                  已邀请（" + _vm._s(_vm.row.type) + "）\n               ")]) : _vm._e(), _vm._v(" "), ([4].includes(_vm.row.inviteStatus)) ? _c('div', [_vm._v("不可邀请")]) : _vm._e(), _vm._v(" "), ([5].includes(_vm.row.inviteStatus)) ? _c('div', [_vm._v("\n                  已拒绝（" + _vm._s(_vm.row.type) + "）\n               ")]) : _vm._e()]
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "210px",
      "align": "center"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return [([1, 3, 5].includes(_vm.row.inviteStatus)) ? _c('el-button', {
            staticStyle: {
              "color": "red"
            },
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.clickRevoke(_vm.row)
              }
            }
          }, [_vm._v("撤销")]) : _vm._e(), _vm._v(" "), ([0, 2].includes(_vm.row.inviteStatus)) ? _c('el-button', {
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.clickInvitation(_vm.row)
              }
            }
          }, [_vm._v("发送邀请")]) : _vm._e(), _vm._v(" "), ([0, 2, 4].includes(_vm.row.inviteStatus)) ? _c('el-button', {
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.clickChangeType(_vm.row)
              }
            }
          }, [_vm._v("变更类型")]) : _vm._e(), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.clickDonate(_vm.row)
              }
            }
          }, [_vm._v("赠送")])]
        
      },
      staticRenderFns: []
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-wrapper"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next, jumper",
      "current-page": _vm.queryParam.pageNum,
      "page-size": _vm.queryParam.pageSize,
      "total": _vm.tableTotal
    },
    on: {
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryParam, "pageNum", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryParam, "pageNum", $event)
      },
      "current-change": _vm.changeCurrentPage
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "custom-class": "dialog-content",
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "80px",
      "inline": true,
      "model": _vm.dialogForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.status ? '发送邀请' : '变更状态'
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.dialogForm.rid),
      callback: function($$v) {
        _vm.$set(_vm.dialogForm, "rid", $$v)
      },
      expression: "dialogForm.rid"
    }
  }, [(_vm.status === 0) ? _c('el-option', {
    attrs: {
      "label": "普通用户",
      "value": 0
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.roles), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendUpdate
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "赠送",
      "size": "tiny",
      "modal-append-to-body": false,
      "destroy-on-close": true
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "flex-row-center"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.donationDialog.visible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.clickDonationDone
          }
        }, [_vm._v("确认")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.donationDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.donationDialog, "visible", $$v)
      },
      expression: "donationDialog.visible"
    }
  }, [_c('el-form', {
    ref: "donationFormRef",
    attrs: {
      "label-width": "100px",
      "label-position": "left",
      "model": _vm.donationParam,
      "rules": _vm.donationDialog.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择类型",
      "prop": "type"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.donationParam.type),
      callback: function($$v) {
        _vm.$set(_vm.donationParam, "type", $$v)
      },
      expression: "donationParam.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "体验卡",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "会员",
      "value": 2
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.donationParam.type == 1),
      expression: "donationParam.type == 1"
    }],
    attrs: {
      "label": "选择体验卡",
      "prop": "experienceCardId"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.donationParam.experienceCardId),
      callback: function($$v) {
        _vm.$set(_vm.donationParam, "experienceCardId", $$v)
      },
      expression: "donationParam.experienceCardId"
    }
  }, _vm._l((_vm.donationDialog.experienceCardOptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('div', [_vm._v("剩余数量：" + _vm._s(_vm.experienceResidualQuantity) + "张")])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.donationParam.type == 2),
      expression: "donationParam.type == 2"
    }],
    attrs: {
      "label": "选择会员",
      "prop": "memberCardId"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.donationParam.memberCardId),
      callback: function($$v) {
        _vm.$set(_vm.donationParam, "memberCardId", $$v)
      },
      expression: "donationParam.memberCardId"
    }
  }, _vm._l((_vm.donationDialog.memberCardOptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.donationParam.type == 1),
      expression: "donationParam.type == 1"
    }],
    attrs: {
      "label": "体验卡数量",
      "prop": "count"
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls": false,
      "min": 0,
      "step": 1
    },
    model: {
      value: (_vm.donationParam.count),
      callback: function($$v) {
        _vm.$set(_vm.donationParam, "count", $$v)
      },
      expression: "donationParam.count"
    }
  }), _vm._v(" "), _c('span', [_vm._v("张")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a5a9e0a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/UserAdminister/UserListing/UserListing.vue
// module id = 934
// module chunks = 0